import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

import {
  CustomerUserPermission,
  ICustomerUser,
} from "./customer-user.interface";
import { ICustomer } from "./customer.interface";
import { Action, Permissions, TAny } from "./globals";
import { IProject, IProjectInduction } from "./project.interface";

import { TEOption } from "@/schemas/project-register.schema";

export interface LabelValue {
  label: string;
  value: string;
}

export type TOptions = {
  id: string;
  label: string;
};

export type FullName = {
  firstName?: string;
  middleName?: string;
  lastName?: string;
};

export interface Address {
  latitude: string;
  longitude: string;
  postalCode?: string;
  radius?: string;
  label?: string;
  areaLocation?: string;
}

export interface Customer {
  id: string;
  name: string;
  officialName: string;
  shortName: string;
}

export interface CustomerTeam {
  id: string;
  name: string;
  position: string;
}

export interface AdminStaffProps {
  id: number;
  name: string;
  mobile: number;
  employeeType: "full time" | "part time";
  email: string;
}

export enum Roles {
  SUPER_ADMIN = "SUPERADMIN",
  ADMIN = "ADMIN",
  MANAGER = "MANAGER",
  STAFF = "STAFF",
}
export interface WorkforceProps {
  id: number;
  name: string;
  workspace: string;
  mobile: number;
  role: string;
  email: string;
}
export interface UserProps {
  id: string;
  firstName: string;
  middleName?: string;
  phoneNumber?: string;
  lastName?: string;
  company: string | null;
  role: Roles;
  email: string;
  token: string;
  image: string;
  permissions:
    | [
        {
          action: string;
          resource: string;
          workspace?: string;
          customer?: string;
        },
      ]
    | CustomerUserPermission;
  unViewedNotifications: number;
}

export type LoginProps = {
  emailOrPhone: string;
  otp?: string;
};

export interface ResponseType {
  data: {
    message: string;
    user?: {
      company?: string;
      email: string;
      id: string;
      name: string;
      role: Roles;
      token: string;
    };
  };
}

export interface getInfoProps {
  id: string;
  email: string;
  name: string;
  phoneNumber: string;
  role: string;
  login_otp: string;
  token: string;
  deviceId: string | null;
  createdAt: string;
  updatedAt: string;
  address: string;
  employmentType: string;
}

export interface CustomerProps {
  id: string;
  name: string;
  abn: string;
  email: string;
  image: string;
  address: string;
  officialName: string;
  phoneNumber: string;
  customerName: string;
  accountEmail: string;
  shortName: string;
  totalUsers: number;
  users?: ICustomerUser[];
}
export interface customerPermission {
  emailNotification: boolean;
  customerPortal: boolean;
  projectFinance: boolean;
}
export interface customerUser {
  id?: string;
  name: string;
  image: string;
  email: string;
  position: string;
  role: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  customerId?: string;
  permissions?: customerPermission;
  user?: {
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    role: string;
  };
}

export interface SingleWorkspaceResponseType {
  message: string;
  id?: string;
  // workspace: Workspace[]
}

export interface Workspace {
  id: string;
  name: string;
  abn: string;
  logo?: string;
  email: string;
  phoneNumber: string;
  state: string;
  subDomain: string;
  createdAt: string;
  updatedAt: string;
  permissionsId?: string | null;
  userAccessListId?: string | null;
  isSyncedWithXero: boolean;
}
export interface User {
  id: string;
  name: string;
  role: string;
  iat?: number;
}

export interface Data {
  user: User;
  token: string;
}

export interface LoginResponseType {
  message: string;
  data?: Data;
}

// export interface GetLoginType {
//   message: string
//   user: User
// }

export interface StateType {
  name: string;
  abbreviation: string;
}
export type StateResponseType = StateType[];

export interface CheckboxState {
  permissionName: string;
  read: boolean;
  write: boolean;
}
export interface Company {
  Company?: { id?: string; companyName?: string };
  id: string;
  companyName: string;
  subdomain: string;
  createdAt: string;
  updatedAt: string;
}

export interface CompanyList {
  Company: Company[];
}

export interface IPermissions {
  actions: Action[];
  resources: { [key: string]: Permissions[] };
}

export interface ResData {
  id: string;
  email: string;
  name: string;
  phoneNumber: string;
  role: string;
  login_otp: string | null;
  token: string | null;
  createdAt: string;
  updatedAt: string;
  Companies: Company[];
}

export interface AddAdminResProps {
  message: string;
  data: ResData;
}
export interface CompanyRes {
  Company: Company;
}

export interface AdminType {
  id: string;
  email: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  status?: string;
  address?: string;
  image?: string;
  phoneNumber: string;
  role: string;
  login_otp?: string | null;
  token?: string | null;
  createdAt: string;
  updatedAt: string;
  employmentType: string;
  deviceId?: string | null;
  Companies: CompanyRes[];
}

export interface AdminResponse {
  message: string;
  admins: AdminType[];
}

export interface Employee {
  id: string;
  role: string;
  name: string;
  phoneNumber: string;
  deviceId: string;
  email: string;
  address: string;
  employmentType: string;
  companyId: string;
  rejectStatus: boolean;
  approvedStatus: boolean;
  verifiedStatus: boolean;
  basicProfileStatus: boolean;
  workDetailsStatus: boolean;
  declarationStatus: boolean;
  company?: Company;
}

export interface EmployeeResponse {
  message: string;
  employees: Employee[];
}

export interface deviceReqType {
  message: string;
  data?: {
    id: string;
    name: string;
    phoneNumber: string;
    email: string;
    company?: Company;
  };
}

export interface PreviousExperience {
  skills: string[];
  Trainings: string[];
  textField: string;
}

export interface EmployeeDetails {
  previousExperience: PreviousExperience;
}

export interface EmployeeReq {
  id: string;
  role: string;
  name: string;
  phoneNumber: string;
  deviceId: string;
  email: string;
  address: string;
  employmentType: string;
  companyId: string;
  rejectStatus: boolean;
  approvedStatus: boolean;
  verifiedStatus: boolean;
  basicProfileStatus: boolean;
  workDetailsStatus: boolean;
  declarationStatus: boolean;
  deviceidRemoveStatus: boolean;
  EmployeeDetails?: EmployeeDetails;
}

export interface LoadType {
  id: string;
  name: string;
  tareWeight: string;
  image: string;
  createdAt: string;
  updatedAt: string;
  workspaceId?: string;
}
export interface WasteType {
  id: string;
  name: string;
  recoveryPathway: string;
  recyclingPercentage: string;
  createdAt: string;
  updatedAt: string;
}

export interface ProjectType {
  id: string;
  name: string;
  startDate: string;
  budgetHours: string;
  isGreenStarProject: boolean;
  referenceNumber: string;
  ProjectInductions: IProjectInduction[];
  customer: Customer[];
  customerTeam: CustomerTeam[];
  createdAt: string;
  updatedAt: string;
  status: string;
  projectNumber: string;
  workspace: Workspace[];
  projects: [];
  address: Address;
}

export interface CustomerProjectType {
  customer: CustomerProps;
  projects: ProjectType[];
}

export interface breakDownDataType {
  otherWaste: {
    id?: string;
    wasteName: string;
    wasteTypeId: string;
  }[];
  mixedWaste: {
    id?: string;
    wasteTypeId: string;
    percentage: string;
    wasteName: string;
  }[];
}

export interface WeighScaleTicketItem {
  id?: string;
  loadTypeId: string;
  loadTypeQuantity: number;
  wasteTypeId: string;
  wasteTypeWeight: number;
  breakDown: boolean;
  breakDownData: breakDownDataType | null;
  weighScaleTicketId: string;
  loadType: LoadType;
  wasteType: WasteType;
}

export interface TippingRecordType {
  companyId: string;
  projectId: string;
  customerId: string;
  id: string;
  ticketNumber: number;
  WeighScaleTicketItems: WeighScaleTicketItem[];
}

export interface ResorceRecoveryDetail {
  id: string;
  isFromTab: boolean;
  ticketNumber: number;
  weighScaleTicketItems: WeighScaleTicketItem[];
}

export interface shiftWorkHour {
  shiftTitle: string;
  time: number;
}

export interface ReportData {
  id: string;
  date: Date;
  reportId?: number;
  workspaceId: string;
  customerId: string;
  createdAt: Date;
  updatedAt: Date;
  projectId: string;
  customer: ICustomer;
  Project: IProject;
  employeeWorkingHours: TAny[];
  subcontractorWorkHours: TAny[];
  resorceRecoveryDetails: ResorceRecoveryDetail[];
  totalEmployeeWorkHourData?: shiftWorkHour[];
  totalSubcontractorWorkHourData?: shiftWorkHour[];
}

export interface Project {
  name: string;
  referenceNumber: string;
  ourReferenceNumber: string;
  customerProjectReference: string;
  customerProjectTeam?: {
    id: string;
    position: string;
    user?: {
      firstName: string;
      middleName: string | null;
      lastName: string;
      email: string;
      phoneNumber: string;
      image: string | null;
      role: string;
    };
  }[];
  ourProjectTeam?: {
    firstName: string;
    middleName: string | null;
    lastName: string;
    role: string;
    email: string;
    employmentType: string;
    image: string;
    address: string;
  }[];
}

export interface Customer {
  officialName: string;
}

export interface WeighScaleTicketItem {
  wasteType: WasteType;
}

export interface WasteType {
  name: string;
  id: string;
}

export interface ProjectInduction {
  id: string;
  inductionName: string;
  inductionValue: string;
}

export interface Workspace {
  id: string;
  companyName: string;
}

export interface SubContractor {
  id: string;
  name: string;
  image: string;
  email: string;
  phoneNumber: string;
  accountEmail: string;
  addressLat: string;
  addressLon: string;
  ABN: string;
  createdAt: string;
  updatedAt: string;
  companyId: string;
  workspace?: Workspace;
}

export interface Prospect {
  id: string;
  name: string;
  officialName: string;
  image: string;
  shortName: string;
  abn: string;
  address: {
    latitude: string;
    longitude: string;
  };
  phoneNumber: string;
  createdAt: string;
  updatedAt: string;
  prospectId: string;
  totalUsers: number;
  accountEmail: string;
  accountName: {
    first: string;
    last: string;
  };
}

export interface ProspectUser {
  id: string;
  name: {
    first: string;
    last: string;
  };
  email: string;
  phoneNumber: string;
  position: string;
  prospectId: string;
  image: string;
  prospectName?: string;
  status?: string;
}

export interface RecoveryBreakDown {
  [x: string]: {
    loadType: string;
    wasteType: string;
    loadQuantity: number;
    netWasteWeight: number;
    totalWasteWeight: number;
    recycledMaterials: string[];
  };
}

export interface TRecoveryPathway {
  REUSE?: number;
  RECYCLE?: number;
  LANDFILL?: number;
  ENERGYCONVERSION?: number;
}

export interface TRecyclingPercentage {
  recyclingPercentage: number;
  nonRecyclingPercentage: number;
}
export interface WasteSummary {
  id: string;
  recoveryPathway: TRecoveryPathway;
  recyclingPercentage: TRecyclingPercentage;
  detailedWasteComposition: object;
  wasteComposition: object;
  wasteVolume: object;
  recoveryBreakDown: RecoveryBreakDown;
  workspaceId: string;
  createdAt: Date;
  updatedAt: Date;
}

export type IDays =
  | "Sunday"
  | "Monday"
  | "Tuesday"
  | "Wednesday"
  | "Thursday"
  | "Friday"
  | "Saturday";

export type IbtnVariant =
  | "link"
  | "default"
  | "destructive"
  | "outline"
  | "secondary"
  | "ghost"
  | "light";

export type TAllowedExportFileTypes = "csv" | "pdf" | "txt" | "xlsx";
export interface ExportFileType {
  name: string;
  sheet: string;
  type: TAllowedExportFileTypes;
}

export type RecoveryPathWayTypes = {
  name: string;
  amt: number;
  fill: string;
};

export type NewTOptions<T> = Omit<TEOption, "for"> & {
  for: T;
};

export type QueryRestType = {
  isLoading: boolean;
  isError: boolean;
  error?: FetchBaseQueryError | SerializedError | undefined;
  refetch?: () => void;
};

enum NotificationType {
  LOGIN = "LOGIN",
  SIGNUP = "SIGNUP",
}

export interface NotificationView {
  id: string;
  createdAt: string;
  updatedAt: string;
  type: NotificationType;
  content: string;
  employeeId: string;
  workspaceId: string;
  employee: {
    id: string;
    user: {
      firstName: string;
      middleName?: string;
      lastName: string;
    };
  };
}
export interface Notification {
  createdAt: string;
  updatedAt: string;
  userId: string;
  notificationId: string;
  isRead: boolean;
  notification: NotificationView;
  // user: {
  //   id: string;
  //   email: string;
  //   firstName: string;
  //   middleName?: string;
  //   lastName: string;
  //   image?: string;
  // };
}
